import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { CONTACT, SERVICES } from "../lib/constants";

export const Footer = () => {
  return (
    <footer className="mt-24 border-t" style={{ borderColor: "var(--hair)", background: "var(--ink-900)" }}>
      <div className="ve-container py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Logo size="lg" />
          <p
            className="mt-6 text-sm leading-relaxed max-w-sm"
            style={{ color: "var(--cream-300)" }}
          >
            Personal real estate consulting across Ahmedabad West. Buy, sell, lease —
            with discretion, deep local intelligence and a straight-talking approach.
          </p>
          <div className="mt-6 flex gap-3">
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="ve-btn-whatsapp"
            >
              WhatsApp
            </a>
            <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-ghost">
              Call Office
            </a>
          </div>
        </div>
        <div className="md:col-span-2">
          <div className="ve-label">Navigate</div>
          <ul className="mt-4 space-y-3 text-sm" style={{ color: "var(--cream-200)" }}>
            <li><Link to="/" className="ve-link-underline">Home</Link></li>
            <li><Link to="/services" className="ve-link-underline">Services</Link></li>
            <li><Link to="/areas" className="ve-link-underline">Areas</Link></li>
            <li><Link to="/about" className="ve-link-underline">About</Link></li>
            <li><Link to="/contact" className="ve-link-underline">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="ve-label">Services</div>
          <ul className="mt-4 space-y-3 text-sm" style={{ color: "var(--cream-200)" }}>
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services#${s.slug}`} className="ve-link-underline">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="ve-label">Office</div>
          <address className="mt-4 text-sm not-italic leading-relaxed" style={{ color: "var(--cream-200)" }}>
            {CONTACT.addressLine1}<br />
            {CONTACT.addressLine2}<br />
            {CONTACT.addressLine3}<br />
            {CONTACT.addressLine4}<br />
            {CONTACT.addressLine5}
          </address>
          <div className="mt-4 text-sm" style={{ color: "var(--cream-200)" }}>
            <div>
              <a href={`tel:${CONTACT.phoneTel}`} className="ve-link-underline">
                {CONTACT.phoneDisplay}
              </a>
            </div>
            <div>
              <a href={`mailto:${CONTACT.email}`} className="ve-link-underline">
                {CONTACT.email}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="py-6" style={{ borderTop: "1px solid var(--hair)" }}>
        <div className="ve-container flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs" style={{ color: "var(--cream-500)" }}>
          <div>© {new Date().getFullYear()} Vachhraj Estate. All rights reserved.</div>
          <div className="tracking-[0.2em] uppercase" style={{ color: "var(--gold-500)" }}>
            Ahmedabad West · Gujarat · India
          </div>
        </div>
        <div className="ve-container pt-2 text-[10px] text-center" style={{ color: "var(--cream-600)" }}>
          All content, design, logos and materials on this website are protected by copyright law. 
          Unauthorized reproduction, distribution or copying is strictly prohibited.
        </div>
      </div>
    </footer>
  );
};

export default Footer;